(() => {
  'use strict';
  const dialog = document.querySelector('[data-bkr-newsletter]');
  if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
  dialog.dataset.initialized = 'true';
  const KEY = 'bkr_newsletter_dismissed_until_v1';
  const SESSION = 'bkr_newsletter_seen_v1';
  const SUBSCRIBED = 'bkr_newsletter_submitted_v1';
  const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;
  let previousFocus;
  let stopped = false;
  let timer;
  let storageReady = false;
  let seen = false;
  const result = dialog.querySelector('[data-newsletter-result]');
  const ownResult = location.hash === '#BkrNewsletterForm' && result;
  const form = dialog.querySelector('form');
  try {
    const probe = `${KEY}_probe`;
    localStorage.setItem(probe, '1'); localStorage.removeItem(probe);
    sessionStorage.setItem(probe, '1'); sessionStorage.removeItem(probe);
    storageReady = true;
    seen = Number(localStorage.getItem(KEY)) > Date.now() || sessionStorage.getItem(SESSION) === '1' || localStorage.getItem(SUBSCRIBED) === '1';
  } catch (_) { /* No reliable persistence: do not automatically interrupt. */ }
  function stop() { stopped = true; clearTimeout(timer); }
  function rememberClose() {
    try { localStorage.setItem(KEY, String(Date.now() + THIRTY_DAYS)); } catch (_) {}
  }
  function visible(el) { return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden'; }
  function busy() {
    if (document.visibilityState !== 'visible') return true;
    if (document.activeElement?.matches('input,textarea,select,[contenteditable=true]')) return true;
    const selectors = 'dialog[open],details[open],#cart-notification.active,cart-drawer.active,modal-dialog[open],pickup-availability-drawer[open],.product-media-modal[open],[role=dialog][aria-modal=true],[aria-busy=true]';
    if ([...document.querySelectorAll(selectors)].some(el => el !== dialog && visible(el))) return true;
    if ([...document.querySelectorAll('input[type=search]')].some(el => visible(el) && el.value.trim())) return true;
    return document.body.classList.contains('bkr-modal-open') || /overflow-hidden/.test(document.body.className);
  }
  function open() {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('bkr-newsletter-open');
    (ownResult ? result : dialog.querySelector('h2')).focus({preventScroll:true});
    try { sessionStorage.setItem(SESSION, '1'); } catch (_) {}
    stop();
  }
  function attempt() {
    if (stopped) return;
    if (busy()) { timer = setTimeout(attempt, 1000); return; }
    open();
  }
  dialog.querySelector('[data-newsletter-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    stop(); rememberClose();
    document.documentElement.classList.remove('bkr-newsletter-open');
    const canRestoreFocus = el => el?.isConnected && el !== document.body && visible(el) && !el.disabled && !el.closest('[inert],[hidden],[aria-hidden="true"]');
    // A breakpoint or rerender can hide/remove the original control while open.
    const candidates = [previousFocus, document.querySelector('#MainContent')];
    for (const target of candidates) {
      if (!canRestoreFocus(target)) continue;
      target.focus({preventScroll:true});
      if (document.activeElement === target) break;
    }
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const items = [...dialog.querySelectorAll('button,a[href],input:not([type=hidden]),select,textarea,[tabindex="0"]')].filter(el => !el.disabled && visible(el));
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  form.addEventListener('submit', () => { stop(); });
  document.addEventListener('submit', event => { if (!dialog.contains(event.target)) stop(); }, true);
  document.addEventListener('click', event => {
    if (dialog.contains(event.target)) return;
    if (event.target.closest('a[href*="/cart"],form[action*="/cart"],[name=add],[data-bkr-open="cart"]')) stop();
  }, true);
  window.addEventListener('pagehide', stop);
  window.addEventListener('storage', event => {
    if (event.key === KEY || event.key === SUBSCRIBED) { stop(); if (dialog.open) dialog.close(); }
  });
  if (ownResult) {
    if (result.dataset.newsletterResult === 'success') {
      try { localStorage.setItem(SUBSCRIBED, '1'); } catch (_) {}
    }
    // Only a Shopify-rendered response for this form may bypass the delay/suppression.
    timer = setTimeout(attempt, 0);
  } else if (storageReady && !seen && dialog.dataset.knownSubscriber !== 'true' && !result && !window.Shopify?.designMode) {
    timer = setTimeout(attempt, 20000);
  }
})();
